// Frans (fr-FR), family: zelfde vorm als family.nl.ts. Tu-vorm, korte zinnen; op de kiosk
// eenvoudige woorden voor kinderen. "jullie" wordt "ta famille"; geen vous.
export const familyFr = {
    nav: {
        wishes: 'Souhaits',
        messages: 'Messages',
        calendars: 'Calendriers',
        family: 'Proches',
    },
    common: {
        save: 'Enregistrer',
        saved: 'Enregistré.',
        add: 'Ajouter',
        edit: 'Modifier',
        remove: 'Retirer',
        undo: 'Annuler',
        copy: 'Copier le lien',
        copied: 'Lien copié.',
        readOnly: 'Lecture seule',
        everyone: 'Tout le monde',
        loading: 'Un instant…',
        retry: 'Réessayer',
        error: 'Un problème est survenu. Réessaie.',
        back: 'Retour',
        close: 'Fermer',
        whoAreYou: 'Qui es-tu ?',
        readAloud: 'Lire à voix haute',
        inDays: { one: 'demain', other: 'dans {count} jours' },
        today: 'aujourd’hui',
        turnsAge: 'aura {age} ans',
        dayOf: 'jour {index} sur {count}',
    },
    wishes: {
        title: 'Souhaits',
        intro: 'Qu’y a-t-il sur les listes d’envies ? Les enfants choisissent eux-mêmes une image sur la tablette.',
        add: 'Ajouter un souhait',
        addShort: 'Souhait',
        listOf: 'Souhaits de {name}',
        editTitle: 'Modifier le souhait',
        newTitle: 'Nouveau souhait',
        fieldTitle: 'Qu’est-ce que c’est ?',
        fieldTitleHint: 'Court et clair, par exemple Draisienne',
        fieldFor: 'Pour qui',
        fieldPicto: 'Image',
        fieldNote: 'Précisions',
        fieldNoteHint: 'Taille, couleur ou marque (facultatif)',
        fieldUrl: 'Lien vers le magasin',
        fieldUrlHint: 'Commence par https:// (facultatif)',
        fieldPrice: 'Environ (€)',
        fieldPriority: 'Envie à quel point ?',
        priority1: 'Un peu',
        priority2: 'Beaucoup',
        priority3: 'Énormément',
        received: 'Reçu',
        markReceived: 'Reçu',
        fromTablet: 'choisi sur la tablette : à préciser ensemble',
        removed: '{title} retiré.',
        receivedToast: '{title} est dans les cadeaux reçus.',
        share: 'Partager',
        shareTitle: 'Partager la liste de {name}',
        shareIntro: 'Toute personne qui a ce lien peut voir la liste et réserver un cadeau, sans compte. {name} ne voit jamais qui achète quoi.',
        shareCreate: 'Créer un lien de partage',
        shareNew: 'Nouveau lien',
        shareNewHint: 'L’ancien lien ne fonctionnera plus.',
        shareStop: 'Arrêter le partage',
        shareStopped: 'La liste n’est plus partagée.',
        shared: 'Partagée',
        reveal: 'Dévoiler',
        revealHint: 'Montre ce qui est déjà acheté. Attention : les enfants peuvent regarder.',
        claimedBy: '{name} achète ceci',
        claimedAnon: 'Quelqu’un achète ceci',
        boughtBy: '{name} l’a acheté',
        boughtAnon: 'Déjà acheté',
        emptyTitle: 'Pas encore de souhaits',
        emptyBody: 'Ajoutes-en un, ou laisse {name} en choisir un sur la tablette.',
        urlInvalid: 'Utilise un lien qui commence par https://',
    },
    share: {
        title: 'Liste d’envies de {name}',
        intro: 'Choisis un cadeau à offrir. {name} ne voit pas qui achète quoi.',
        claim: 'J’achète ceci',
        claimTitle: 'Offrir ce cadeau',
        claimName: 'Ton prénom (facultatif)',
        claimNameHint: 'Pour que les autres voient que c’est réglé.',
        claimConfirm: 'J’achète ceci',
        mine: 'Tu achètes ceci',
        mineBought: 'Tu as acheté ceci',
        bought: 'Acheté',
        release: 'Finalement non',
        taken: 'Quelqu’un achète déjà ceci',
        takenBy: '{name} achète déjà ceci',
        goneTitle: 'Ce lien ne fonctionne plus',
        goneBody: 'Demande un nouveau lien.',
        emptyTitle: 'La liste est encore vide',
        emptyBody: 'Reviens plus tard.',
        footer: 'Créé avec le tableau familial d’AMUMIN. Aucun compte nécessaire.',
        toWebshop: 'Voir dans le magasin',
    },
    days: {
        title: 'Calendriers',
        intro: 'Les anniversaires, les jours fériés, les vacances scolaires et les agendas associés apparaissent tout seuls dans l’agenda.',
        upcoming: 'Bientôt',
        upcomingEmpty: 'Rien de particulier dans les semaines à venir.',
        layers: 'Qu’est-ce qui figure dans l’agenda ?',
        layerBirthdays: 'Anniversaires',
        layerBirthdaysHint: 'De la famille et des proches qui partagent leurs anniversaires.',
        layerHolidays: 'Jours fériés',
        layerHolidaysHint: 'Fête du Roi, Pâques, Noël et des jours comme la fête des mères.',
        layerSchool: 'Vacances scolaires',
        region: 'Région',
        regionNoord: 'Nord',
        regionMidden: 'Centre',
        regionZuid: 'Sud',
        regionOff: 'Désactivé',
        regionHint: 'Dans quelle région est l’école de tes enfants ? Automne, Noël, printemps et mai sont des dates indicatives.',
        birthdays: 'Anniversaires',
        birthdaysHint: 'Indique une date de naissance, et l’anniversaire apparaît dans l’agenda.',
        birthDate: 'Date de naissance de {name}',
        birthDateSaved: 'L’anniversaire de {name} est dans l’agenda.',
    },
    feeds: {
        title: 'Agendas associés',
        add: 'Associer un agenda',
        addTitle: 'Associer un agenda',
        intro: 'Récupère automatiquement l’école, le sport et le travail. Mis à jour toutes les demi-heures.',
        provider: 'D’où vient l’agenda ?',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'Autre',
        },
        howto: {
            google: 'Paramètres de l’agenda → Intégrer l’agenda → Adresse secrète au format iCal.',
            icloud: 'Calendrier → partager le calendrier → Calendrier public → copier le lien webcal.',
            outlook: 'Paramètres → Calendrier → Calendriers partagés → Publier → lien ICS.',
            parro: 'Parro → Paramètres → Associer l’agenda → copier le lien.',
            magister: 'Magister → Agenda → Partager l’agenda → copier le lien.',
            sportlink: 'Voetbal.nl → Programme → Ajouter à ton agenda → copier le lien iCal.',
            other: 'Tout lien qui se termine par .ics ou commence par webcal:// fonctionne.',
        },
        url: 'Lien',
        urlHint: 'Commence par webcal:// ou https://',
        name: 'Nom',
        namePlaceholder: 'Par exemple École',
        forWho: 'Pour qui',
        forWhoHint: 'Personne de choisi = tout le monde.',
        review: 'Montrer d’abord les éléments inconnus',
        reviewHint: 'Pratique pour un seul agenda scolaire pour plusieurs enfants.',
        rules: 'Règles',
        rulesHint: 'C’est dans le titre ? Alors c’est pour…',
        ruleContains: 'Texte',
        rulePlaceholder: 'par exemple groep 3',
        addRule: 'Ajouter une règle',
        connect: 'Associer',
        connected: '{name} est associé : {count} événements.',
        refresh: 'Actualiser',
        refreshed: 'Mis à jour.',
        remove: 'Dissocier',
        removeConfirm: 'Dissocier l’agenda {name} ? Ses événements disparaissent de l’agenda de ta famille.',
        removed: '{name} est dissocié.',
        statusOk: 'Mis à jour {ago}',
        statusNew: 'Pas encore récupéré',
        statusStale: 'Pas à jour : injoignable depuis un jour',
        statusError: 'Échec : {error}',
        items: { one: '{count} événement', other: '{count} événements' },
        reviewCount: 'Inconnus ({count})',
        reviewTitle: 'C’est pour qui ?',
        reviewIntro: 'Choisis pour chaque événement à qui il est destiné. Ça reste ainsi, même après l’actualisation.',
        hide: 'Masquer',
        assign: 'Attribuer',
        readonlyNote: 'Le titre et l’heure viennent de l’agenda associé.',
        emptyTitle: 'Aucun agenda associé',
        emptyBody: 'Récupère automatiquement l’école, le sport et le travail.',
    },
    links: {
        title: 'Famille et amis',
        intro: 'Associe papi et mamie, l’autre parent ou des amis. Tu choisis toi-même ce que ta famille partage.',
        add: 'Associer des proches',
        addTitle: 'Associer des proches',
        codeHave: 'Tu as reçu un code ?',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'Voir',
        kind: 'Qui est-ce ?',
        kinds: {
            grandparents: 'Papi et mamie',
            coparent: 'L’autre parent',
            family: 'Famille',
            friends: 'Amis',
        },
        label: 'Comment les appelle-t-on chez toi ?',
        labelPlaceholder: 'Par exemple Papi et mamie Martin',
        via: 'Comment inviter ?',
        viaEmail: 'Par e-mail',
        viaCode: 'Avec un code',
        email: 'Adresse e-mail',
        share: 'Qu’est-ce que ta famille partage ?',
        scopeAgenda: 'Agenda de',
        scopeAgendaHint: 'Seulement les événements des enfants que tu choisis.',
        scopeBirthdays: 'Anniversaires',
        scopeWishlists: 'Listes d’envies',
        scopeContact: 'Coordonnées',
        scopeMessages: 'Messages',
        scopeMessagesHint: 'Ils peuvent participer aux conversations où tu les ajoutes.',
        invite: 'Inviter',
        invited: 'Invitation envoyée à {email}.',
        codeReady: 'Donne ce code à {label}',
        codeValid: 'Valable jusqu’au {date}. Ils le saisissent dans Proches → Tu as reçu un code ?',
        weShare: 'Nous partageons',
        theyShare: 'Ils partagent',
        nothing: 'rien pour l’instant',
        statusPending: 'invités',
        statusActive: 'associés',
        statusRevoked: 'dissociés',
        statusEnded: 'dissociés par eux',
        expires: 'expire le {date}',
        view: 'Voir',
        adjust: 'Modifier',
        revoke: 'Dissocier',
        revokeInvite: 'Retirer',
        remove: 'Supprimer',
        guestMoreDays: 'Afficher {count} jours de plus',
        endedHint: 'Ils ont arrêté l’association. Retire-la ici ; tu peux toujours en refaire une.',
        revokeConfirm: 'Rompre l’association avec {label} ? Aucune des deux familles ne verra plus rien de l’autre.',
        revoked: 'Association rompue.',
        previewTitle: '{name} veut s’associer',
        previewShares: 'Ils partagent avec ta famille :',
        accept: 'Associer',
        accepted: 'Associé à {name}. Choisis ci-dessous ce que ta famille partage en retour.',
        acceptLabel: 'Comment les appelle-t-on chez toi ?',
        inviteGone: 'Cette invitation n’existe pas (ou plus) ou a déjà été utilisée.',
        linkGoneTitle: 'Ce lien ne fonctionne plus',
        linkGoneBody: 'Demande un nouveau code, ou saisis-le ci-dessous.',
        toFamily: 'Aller à Proches',
        emailMismatch: 'Cette invitation est pour une autre adresse e-mail.',
        alreadyLinked: 'Ta famille est déjà associée.',
        contactTitle: 'Notre fiche contact',
        contactHint: 'Visible seulement par les proches avec qui tu partages tes coordonnées.',
        address: 'Adresse',
        phone: 'Téléphone',
        contactEmail: 'E-mail',
        note: 'Note',
        emptyTitle: 'Personne d’associé pour l’instant',
        emptyBody: 'Associe papi et mamie : ils voient les anniversaires et les souhaits, et peuvent envoyer des petits messages.',
        guestTitle: '{name}',
        guestNothing: 'Rien de partagé pour l’instant',
        guestNothingBody: 'Ils choisissent eux-mêmes ce qu’ils montrent.',
        guestAgenda: 'Agenda (14 jours)',
        guestBirthdays: 'Anniversaires bientôt',
        guestWishes: 'Souhaits',
        guestContact: 'Contact',
        guestNoEvents: 'Aucun événement dans les deux semaines à venir.',
    },
    messages: {
        title: 'Messages',
        intro: 'En sécurité : seulement la famille et les proches associés. Pas de publicité, pas d’algorithmes.',
        parentsReadAll: 'Les parents peuvent lire toutes les conversations, aussi celles des enfants.',
        family: 'Famille',
        add: 'Conversation',
        addTitle: 'Nouvelle conversation',
        fieldTitle: 'Nom de la conversation',
        fieldTitlePlaceholder: 'Par exemple Papi et mamie',
        fieldWho: 'Qui participe ?',
        fieldLinks: 'Proches associés',
        fieldLinksHint: 'Seulement les proches avec qui ta famille partage les messages.',
        create: 'Créer la conversation',
        placeholder: 'Écris un message…',
        send: 'Envoyer',
        stickers: 'Autocollants',
        record: 'Enregistrer',
        recording: 'Enregistrement… touche pour arrêter',
        voice: 'Message vocal',
        play: 'Écouter',
        hidden: 'Message masqué par un parent',
        hide: 'Masquer',
        fromLinked: 'Des proches associés',
        pickConversation: 'Choisis une conversation',
        emptyTitle: 'Pas encore de messages',
        emptyBody: 'Commence dans la conversation de famille.',
        kidEmptyBody: 'Envoie un autocollant !',
        newMessages: 'nouveaux messages',
        noMember: 'Lie d’abord ton compte à un membre de la famille pour envoyer des messages.',
        sticker: 'Autocollant',
    },
    phrase: {
        love: 'Je t’aime',
        comeHome: 'Tu rentres à la maison ?',
        hungry: 'J’ai faim',
        done: 'Fini !',
        miss: 'Tu me manques',
        play: 'Tu viens jouer ?',
    },
    wishPicto: {
        gift: 'Petit cadeau',
        play: 'Doudou',
        puzzle: 'Puzzle',
        drawing: 'Matériel de dessin',
        crafts: 'Bricolage',
        reading: 'Livre',
        gaming: 'Console de jeux',
        cycling: 'Vélo',
        soccer: 'Foot',
        skating: 'Rollers',
        swimming: 'Affaires de piscine',
        dance: 'Cours de danse',
        'music-lesson': 'Cours de musique',
        guitar: 'Guitare',
        piano: 'Piano',
        drums: 'Batterie',
        unicorn: 'Licorne',
        dino: 'Dinosaure',
        rocket: 'Fusée',
        bear: 'Ours',
        rabbit: 'Lapin',
        cat: 'Chat',
        dolphin: 'Dauphin',
        butterfly: 'Papillon',
        rainbow: 'Arc-en-ciel',
        sunflower: 'Fleurs',
        'ice-cream': 'Glace',
        pizza: 'Pizza',
        popcorn: 'Pop-corn',
        cinema: 'Aller au cinéma',
        zoo: 'Aller au zoo',
        museum: 'Aller au musée',
        camping: 'Camping',
        sleepover: 'Soirée pyjama',
        party: 'Fête',
        trophy: 'Coupe',
    },
    kiosk: {
        wishesEntry: 'Souhaits',
        messagesEntry: 'Messages',
        myWishes: 'Mes souhaits',
        newWish: 'Nouveau souhait',
        pickPicture: 'Choisis une image',
        howMuch: 'Tu en as très envie ?',
        addToList: 'Sur ma liste',
        removeAsk: 'Retirer ?',
        wishAdded: 'C’est sur ta liste !',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'C’est sur ta liste',
        noWishes: 'Pas encore de souhaits',
        noWishesBody: 'Touche le plus et choisis une image.',
        conversations: 'Conversations',
        unread: { one: '{count} nouveau', other: '{count} nouveaux' },
        wishRemoved: '{title} est retiré',
        messageSent: 'Envoyé',
        oops: 'Oups',
        typeOwn: 'Écrire',
        typeLabel: 'Ton message',
        typePlaceholder: 'Tu veux dire quoi ?',
        send: 'Envoyer',
        closeTyping: 'J’ai fini d’écrire',
        notYou: 'Ce n’est pas toi ?',
        newMessages: 'Nouveaux messages',
        alreadyOnList: 'C’est déjà sur ta liste !',
        alreadyOnListCalm: 'C’est déjà sur ta liste',
        morePictures: 'Plus d’images',
        morePhrases: 'Plus de phrases',
    },
};
//# sourceMappingURL=family.fr.js.map